import { ListYearEndAdjustmentInstancesByTagInputSchema, YearEndAdjustmentOverallStatusSchema, yearEndAdjustmentDocumentItemKeyValues } from '@standandforce/api-contract';
import { z } from 'zod';

/** oRPC `YearEndAdjustmentOverallStatusSchema` の値（フィルター UI の列挙用） */
export const YEAR_END_ADJUSTMENT_OVERALL_STATUSES = YearEndAdjustmentOverallStatusSchema.options;

/** 書類タブ（'all' + カタログ順の書類キー。書類リストは SECTION_KEYS から導出） */
export const YEAR_END_ADJUSTMENT_DOCUMENT_TABS = ['all', ...yearEndAdjustmentDocumentItemKeyValues] as const;

/** oRPC listByTag の orderBy（URL search と同期） */
const YEAR_END_ADJUSTMENT_CONFIRMATION_ORDER_BY = ListYearEndAdjustmentInstancesByTagInputSchema.shape.orderBy.unwrap().options;
const yearEndAdjustmentConfirmationOrderBySchema = z.enum(YEAR_END_ADJUSTMENT_CONFIRMATION_ORDER_BY);
const yearEndAdjustmentOverallStatusSchema = z.enum(YEAR_END_ADJUSTMENT_OVERALL_STATUSES);
export const YearEndAdjustmentConfirmationSearchSchema = z.object({
  operationPackageId: z.string().min(1),
  operationPackagePatternId: z.string().min(1),
  tagId: z.string().min(1),
  pageIndex: z.number().int().nonnegative().catch(0),
  pageSize: z.number().int().positive().max(2000).catch(50),
  orderBy: yearEndAdjustmentConfirmationOrderBySchema.optional().catch(undefined),
  orderDirection: z.enum(['asc', 'desc']).optional().catch(undefined),
  searchText: z.string().max(500).optional().catch(undefined),
  status: z.array(yearEndAdjustmentOverallStatusSchema).optional().catch(undefined),
  documentTab: z.enum(YEAR_END_ADJUSTMENT_DOCUMENT_TABS).optional().catch(undefined)
});
export type YearEndAdjustmentConfirmationSearch = z.infer<typeof YearEndAdjustmentConfirmationSearchSchema>;
export type YearEndAdjustmentConfirmationOrderBy = (typeof YEAR_END_ADJUSTMENT_CONFIRMATION_ORDER_BY)[number];
export type YearEndAdjustmentDocumentTab = (typeof YEAR_END_ADJUSTMENT_DOCUMENT_TABS)[number];